import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const PictureMobile = props => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 1200, quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.images.edges.find(n => {
        return n.node.relativePath.includes(props.filename)
      })
      if (!image) {
        return null
      }

      const imageFluid = image.node.childImageSharp.fluid
      return (
        <Img
          className="picture"
          alt={props.alt}
          fluid={imageFluid}
          imgStyle={{ objectFit: "contain", backgroundColor: "black" }}
        />
      )
    }}
  />
)

export default PictureMobile
